import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Typography, Grid, Box, Button } from '@mui/material'

import { Error } from '@mui/icons-material'
import ErrorIcon from '@/assets/img/bg404.svg'
import routes from '@/routes'

import useStyles from './style'

type Props = {
  message: string | undefined
  runtimeError?: boolean
}

const MessageErrorComponent = ({ message, runtimeError }: Props) => {
  const { classes } = useStyles()

  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleReturnHome = () => {
    navigate(routes.reports.INDEX)
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={
        !runtimeError
          ? {
              backgroundImage: `url(${ErrorIcon})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              height: '75vh',
            }
          : { height: '75vh' }
      }
    >
      <Grid component={Box} textAlign="center" item xs={8}>
        {runtimeError ? (
          <Error fontSize="large" className={classes.iconError} />
        ) : (
          <Typography variant="h3" gutterBottom align="center" fontWeight={700}>
            {t('error.pageNotFound')}
          </Typography>
        )}
        <Typography gutterBottom align="center">
          {message}
        </Typography>
        <Box mt={2} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleReturnHome}
          >
            {t('error.returnToHomepage')}
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}

export default MessageErrorComponent
